import { PENDING_ONBOARDING_USER_ID_KEY } from "./constants";

/** Tab-scoped bridge from SSO callback → dashboard age verification. */
export function setPendingOnboardingUserId(userId: string): void {
  if (typeof window === "undefined" || !userId.trim()) {
    return;
  }
  sessionStorage.setItem(PENDING_ONBOARDING_USER_ID_KEY, userId.trim());
}

export function getPendingOnboardingUserId(): string | null {
  if (typeof window === "undefined") {
    return null;
  }
  const stored = sessionStorage.getItem(PENDING_ONBOARDING_USER_ID_KEY);
  if (!stored?.trim()) {
    return null;
  }
  return stored.trim();
}

export function clearPendingOnboardingUserId(): void {
  if (typeof window === "undefined") {
    return;
  }
  sessionStorage.removeItem(PENDING_ONBOARDING_USER_ID_KEY);
}

export function consumePendingOnboardingUserId(): string | null {
  const userId = getPendingOnboardingUserId();
  clearPendingOnboardingUserId();
  return userId;
}
